export enum UserEnum {
    TYPE_BUSINESS_SUPPORT = 6,
    TYPE_BUSINESS_EMPLOYEE = 5,
}
